<template>
  <section>
    <div
      v-if="!onlyShare"
      class="box">
      <div class="flex-sb">
        <span class="title">{{ isFina ? 'Referrer':'Customer' }}</span>
        <span
          v-if="isEdit&&showCustomer"
          class="edit blue"
          @click="handlerAttach">Edit</span>
      </div>
      <div v-if="showCustomer">
        <div>
          <div class="flex flex-align-center">
            <div class="customer-ava">
              <img
                v-if="avt_pic"
                ref="img"
                :src="avt_pic">
              <template v-else>
                <img
                  v-if="customer.identity==1"
                  src="@/assets/images/icon/Personal-icon.png">
                <img
                  v-else-if="customer.identity==2"
                  src="@/assets/images/icon/Company-icon.png">
              </template>
            </div>
            <span
              v-if="[1,2].includes(customer.identity)"
              class="span-status">{{customer.identity==1?'Personal':'Company'}}</span>
            <router-link
              :to="{path:'/accounts/detail',query:{customer_id:customer_id}}"
              class="flex flex-wrap text-decoration-none">
              <span
                v-if="isShowName"
                class="plan-name hand"
                @click="viewCustomer">{{ customer.isrd_nm }} &nbsp;</span>
              <span
                v-else
                class="plan-name hand unname"
                @click="viewCustomer">Unnamed Account &nbsp;</span>
              <span
                v-if="customer.identity==1 && customer.nick_name"
                class="plan-name small hand"
                @click="viewCustomer">({{ customer.nick_name }})</span>
            </router-link>
          </div>
          <ul>
            <li>
              <span>UID</span>
              <span>{{ customer_id }}</span>
            </li>
            <li>
              <span>Joined</span>
              <span>{{ customer.created_at }}</span>
            </li>
            <li>
              <span>Policy Count</span>
              <span>{{customer.polices }}</span>
            </li>
            <li>
              <span>Tags</span>
              <span>
                <span
                  v-if="[0,1].includes(user_agreement_1)"
                  class="flex flex-align-center mg-b-4">
                  <font-awesome-icon
                    icon="square-check"
                    class="mg-r-3 fs-12 fw-400"
                    :class="{'pending_verify-color':user_agreement_1==0,'verified-color':user_agreement_1==1} "></font-awesome-icon>
                  <span
                    class="fs-12 fw-400"
                    :class="{
                      'pending_verify-color': user_agreement_1 ==0,
                      'verified-color': user_agreement_1 == 1,
                    }">{{getOptionName('user_agreement_option',user_agreement_1) }}</span>
                </span>
                <div
                  v-if="customerProfile.upload_request_stts == 1 || customerProfile.is_tier_base || customerProfile.referral_coupon || customerProfile.referral_discount"
                  class="tag">
                  <div
                    v-if="customerProfile.upload_request_stts == 1"
                    class="span-tag unread-uplod">Unread Upload</div>
                  <div
                    v-if="customerProfile.is_tier_base"
                    class="span-tag professional-status">Professional</div>
                  <div
                    v-if="customerProfile.referral_coupon"
                    class="span-tag coupon-status">Custom Coupon</div>
                  <div
                    v-if="customerProfile.referral_discount"
                    class="span-tag discount-status">Custom Discount</div>
                </div>

                <div
                  v-if="customerProfile.verify_language"
                  class="tag">
                  <div
                    class="span-tag"
                    :class="{
                      'verified': customerProfile.verified == 20,
                      'pending_verify ': customerProfile.verified == -1,
                      'not_verify': customerProfile.verified == -2
                    }">{{ customerProfile.verify_language }}</div>
                </div>

                <div
                  v-if="customerProfile.is_flagged"
                  class="tag">
                  <div class="span-tag unread-uplod">
                    Flagged
                  </div>
                </div>
                <div
                  v-if="hasBlockData"
                  class="tag">
                  <div class="span-tag not_verify">
                    Blocked
                  </div>
                </div>
              </span>
            </li>
          </ul>
        </div>
        <div class="flex-sb">
          <span class="label">Description</span>
          <span
            class="edit blue"
            @click="editDescription('edit-description')">Edit</span>
        </div>
        <div
          class="description-content"
          v-html="customer_description">
        </div>
      </div>
      <div
        v-if="!showCustomer&&canCustomerAdd"
        class="button-width mg-b-16">
        <v-button
          gray
          icon="plus"
          class="button-weight"
          @click="handlerAttach">Add {{ isFina ? 'Referrer':'Customer' }}
        </v-button>
      </div>
      <div
        v-if="hasOriginal"
        class="box-show">
        <div class="flex flex-sb">
          <span class="title">Original Contact</span>
        </div>
        <ul class="margin-top-none">
          <li>
            <span>Name</span>
            <span>{{ contact_data.contact_nm }}</span>
          </li>
          <li>
            <span>Email</span>
            <span class="email">
              {{ contact_data.contact_email }}
              <email-tooltip
                class="tips"
                :email="contact_data.contact_email"></email-tooltip>
            </span>
          </li>
          <li>
            <span>Phone</span>
            <span>{{ contact_data.contact_phone }}</span>
          </li>
        </ul>

      </div>
      <contact-customer
        :customerId="isEnquriy?customerProfile.id:customer_id"
        :phone="!customerProfile.id&&isEnquriy?detailData.phone:phone"
        :is-input="!customerProfile.id&&isEnquriy"
        :is-policy="isPolicy"
        :is-ticket="isTicket"
        :is-quote="isQuote"
        :is-enquiry="isEnquriy"
        :customerName="customerProfile.isrd_nm"
        :email="!customerProfile.id&&isEnquriy?detailData.email:email"
        @success='handleSuccess' />
    </div>

    <div
      v-if="isShare"
      class="box">
      <div class="flex-sb-center share-content">
        <span class="label">Sharing With</span>
        <span
          v-if="shareInfo.id"
          class="blue hand"
          @click="handleUnShare">Don't Share</span>
      </div>
      <template v-if="shareInfo.id">
        <router-link
          :to="{path:'/accounts/detail',query:{customer_id:shareInfo.id}}"
          class="flex blue flex-wrap text-decoration-none">
          <span
            class="name blue hand"
            @click="viewShareCustomer"
          >{{ shareInfo.isrd_nm }} &nbsp;</span>
        </router-link>
        <ul>
          <li>
            <span>UID</span>
            <span>{{ shareInfo.id }}</span>
          </li>
          <li>
            <span>Joined</span>
            <span>{{ shareInfo.created_date || '-' }}</span>
          </li>
          <li>
            <span>Policy Count</span>
            <span>{{ shareInfo.policys || 0 }}</span>
          </li>
          <li>
            <span>Tags</span>
            <span>
              <div
                v-if="shareInfo.upload_request_stts == 1 || shareInfo.is_tier_base || shareInfo.referral_coupon || shareInfo.referral_discount"
                class="tag">
                <div
                  v-if="shareInfo.upload_request_stts == 1"
                  class="span-tag unread-uplod">Unread Upload</div>
                <div
                  v-if="shareInfo.is_tier_base"
                  class="span-tag professional-status">Professional</div>
                <div
                  v-if="shareInfo.referral_coupon"
                  class="span-tag coupon-status">Custom Coupon</div>
                <div
                  v-if="shareInfo.referral_discount"
                  class="span-tag discount-status">Custom Discount</div>
              </div>

              <div
                v-if="shareInfo.verify_language"
                class="tag">
                <div
                  class="span-tag"
                  :class="{
                    'verified': shareInfo.verified == 20,
                    'pending_verify ': shareInfo.verified == -1,
                    'not_verify': shareInfo.verified == -2
                  }">{{ shareInfo.verify_language }}</div>
              </div>

              <div
                v-if="shareInfo.is_flagged"
                class="tag">
                <div class="span-tag unread-uplod">
                  Flagged
                </div>
              </div>
            </span>
          </li>
        </ul>
        <div class="flex-sb">
          <span class="label">Description</span>
          <span
            class="edit blue"
            @click="editDescription('edit-share-description')">Edit</span>
        </div>
        <div
          class="description-content mg-b-0"
          v-html="share_customer_description">
        </div>
      </template>
      <template v-else>
        <v-button
          gray
          icon="user-friends"
          @click="handlerShare">Share with Another User</v-button>
      </template>
    </div>
  </section>
</template>

<script>
import ContactCustomer from '@/views/components/new-contact-customer'
import MixinOptions from '@/mixins/options'
export default {
  name: 'right-customer-detail',
  components:{
    ContactCustomer
  },
  mixins: [MixinOptions],
  props:{
    detailData:{
      type:Object,
      default:()=>({})
    },
    customerProfile:{
      type:[Object,Array],
      default:()=>({})
    },
    hasBlockData:{
      type:Boolean,
      default:false
    },
    showCustomer:{
      type:Boolean,
      default:false
    },
    isEdit:{
      type:Boolean,
      default:false
    },
    hasOriginal:{
      type:Boolean,
      default:false
    },
    canCustomerAdd:{
      type:Boolean,
      default:false
    },
    isShare:{
      type:Boolean,
      default:true
    },
    onlyShare:{
      type:Boolean,
      default:false
    },
    isPolicy:{
      type:Boolean,
      default:false
    },
    isQuote:{
      type:Boolean,
      default:false
    },
    isEnquriy:{
      type:Boolean,
      default:false
    },
    isTicket:{
      type:Boolean,
      default:false
    },
    isFina:{
      type:Boolean,
      default:false
    },
  },
  computed:{
    isPersonal(){
      let {cust_typ} = this.detailData||{}
      return cust_typ == 1
    },
    contact_data(){
      let {contact_data} = this.detailData||{}
      return contact_data||{}
    },
    user_agreement_1(){
      let {user_agreement_1} = this.customerProfile||{}
      return user_agreement_1
    },
    phone(){
      let {phone,phone_no,mobile_no,contact_phone,customer={}} = this.detailData||{}
      let {identity} = this.customer
      if(this.isTicket||this.isEnquriy){
        if(identity==2)
          return this.customer.contact_phone
        return  this.customer.phone||this.customer.contact_phone
      }
      if(this.isPolicy)
        return this.isPersonal?mobile_no:contact_phone||phone_no
      return phone
    },
    email(){
      let {email,send_email} = this.detailData||{}
      if(this.isFina&&this.isTicket){
        return   this.referrer.email||this.referrer.send_email
      }
      if(this.isEnquriy)
        return this.customerProfile.email
      if(this.isPolicy)
        return email
      return send_email
    },
    isShowName(){
      let {isrd_nm} = this.customer||{}
      if(isrd_nm)
        return isrd_nm.trim()!=''
      else return  false
    },
    avt_pic(){
      const {avatar_pic={}} = this.detailData
      return avatar_pic&&avatar_pic.url||''
    },
    shareInfo(){
      if(this.ticket)
        return  this.shareInitiator
      let {share_user_infos} = this.detailData||{}
      return share_user_infos||{}
    },
    shareInitiator(){
      let {share_initiator} = this.referDetail
      return share_initiator
    },
    referrer(){
      let {customer,relation={}} = this.detailData||{}
      let {referrer} = relation
      return referrer||{}
    },
    customer_id(){
      let {customer_id,relation={},referrer} = this.detailData||{}
      if(this.isTicket&&this.isFina)
        return  this.referrer.id
      if(this.isFina&&this.isEnquriy)
        return this.customerProfile.id
      return customer_id
    },
    customer(){
      let {customer,relation={},referrer} = this.detailData||{}
      if(this.isTicket&&this.isFina)
        return  this.referrer||{}
      if(this.isFina&&this.isEnquriy)
        return this.customerProfile
      return customer||{}
    },
    share_customer_description(){
      let {description} = this.shareInfo||{}
      let str = description||''
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },
    customer_description(){
      let {description} = this.customerProfile||{}

      let str = description||''
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },

  },
  methods:{
    handlerAttach(){
      this.$emit('attach')
    },
    viewCustomer(){
      this.$emit('view')
    },
    editDescription(type){
      this.$emit('editDes',type)
    },
    handlerShare(){
      this.$emit('share')
    },
    viewShareCustomer() {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.shareInfo.id
        }
      })
    },
    handleUnShare(){
      this.$emit('unShare')
    },
    handleSuccess(){
      this.$emit('success')
    }
  }
}
</script>

<style scoped lang="scss">
.flex-align-center{
  align-items: center;
}
.customer-ava{
  height: 28px;
  width: 28px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #DBEDFF;
  margin-right: 10px;
  img{
    width: 28px;
    display: block;
    border-radius: 50%;
  }
}
.flex-wrap{
  flex-wrap: wrap;
}
.span-status{
  color: #fff;
  padding: 2px 10px;
  border-radius: 100px;
  margin-right: 15px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
.hand{
  cursor:pointer;
}
.unname{
  font-style:italic;
  font-weight: normal!important;
}
.plan-name{
  color: #0366D6;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
}
ul {
  margin-top: 15px;
  li {
    display: flex;
    padding: 5px;
    list-style: none;
    color: #606266;
    font-size: 12px;
    line-height: 14px;
    span {
      flex: 1;
      .tag{
        .span-tag{
          display: inline-block;
          border-radius: 100px;
          height: 18px;
          background: #FFFFFF;
          padding: 0px 8px;
          font-weight: 600;
          font-size: 12px;
          line-height: 18px;
          box-sizing: content-box;
          white-space: nowrap;
          margin-bottom: 4px;
          &.verified{
            border: 1px solid #22863a;
            color: #22863a;
          }
          &.pending_verify{
            border: 1px solid #dbab09;
            color: #dbab09;
          }
          &.not_verify{
            border: 1px solid #d73a49;
            color: #d73a49;
          }
          &.unread-uplod{
            border: 1px solid #f66a0a;
            color: #c24e00;
          }
          &.professional-status, &.coupon-status, &.discount-status{
            border: 1px solid #0366d6;
            color: #0366d6;
          }
          &.green {
            background: #DCFFE4;
            color: #28A745;
            border: none;
          }
          &.orange {
            background-color:#FFF5B1 ;
            color:  #B08800;
            border: none;
          }
          &.red {
            background: #D73A49;
            color:#fff;
            border: none;
          }
        }
      }
    }

    span:first-child {
      font-weight: bold;
    }
  }
  li:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  li:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  margin-bottom: 15px;
}
span.edit{
  color: #0366D6;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}
.description-content{
  font-weight: 400;
  font-size: 14px;
  color: #24292E;
  margin-bottom: 15px;
  &.mg-b-0{
    margin-bottom: 0;
  }
}
.title {
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 5px;
  font-size: 14px;
  font-weight: bold;
}
.box{
  padding: 29.5px 0;
  border-bottom: 1px solid #D1D5DA;
  .status{
    color: #68C23A
  }
}
.span-status{
  border: 1px solid #616266;
  color: #616266;
}
.box-show{
  background: #F6F8FA;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
  .title{
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
  }
  .email{
    word-break: break-all;
    position: relative;
    .tips{
      position: absolute;
    }
  }
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}
</style>
